import styled from 'styled-components';

import { black, blue, gray } from 'utils/style/colors';

import Icon from 'components/Icon';

interface IItemViewerWrapperProps {
  selected: boolean;
  disabled: boolean;
}

export const ItemViewerName = styled('span')`
  flex: 1;
  color: ${black};
  padding: 0 1.2rem;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 400;
  text-overflow: ellipsis;
`;

export const ItemViewerArrow = styled(Icon)`
  left: 0.6rem;
  color: #787878;
  width: 25px;
  height: 25px;
  cursor: pointer;
  display: none;
  position: relative;
  font-size: 1.5rem !important;
  align-items: center;
  margin-right: 0 !important;
  border-radius: 10px;
  justify-content: center;
  :hover {
    background-color: rgba(0, 0, 0, 0.12);
  }
`;

export const ItemViewerWrapper = styled('li')<IItemViewerWrapperProps>`
  color: ${black};
  cursor: ${({ disabled }) => (disabled ? '' : 'pointer')};
  display: flex;
  min-height: 2.5rem;
  transition: all 0.1s ease;
  align-items: center;
  padding-right: 1.2rem;
  padding-left: 1.2rem;
  background-color: var(--exact-white);

  ${({ selected, disabled }) =>
    selected
      ? `
  color: var(--exact-white);
  background-color: ${blue};
  & > ${ItemViewerArrow} {
    display: inline-flex;
  }
  & > * {
    color: var(--exact-white) !important;
  }
`
      : disabled
        ? `
      color: ${gray}
        & > * {
    color: ${gray};
  }
      `
        : `:hover {
  background: #f1f1f1;
  & > ${ItemViewerArrow} {
    display: inline-flex;
  }`}}
`;
